import { createSelector } from '@reduxjs/toolkit';
import { JSONApiDataObject, JSONApiRelationshipObject } from 'Douleutaras/types';

/**
 * Gets entities from relations of a single entity (JSON-API) object
 */
export const getRelationEntitiesFromSingleEntity = (
    selectMainSingleEntity,
    selectRelationEntities,
    selectRelationEntityName
  ) => createSelector(
  selectMainSingleEntity,
  selectRelationEntities,
  (mainEntity: JSONApiDataObject<typeof selectMainSingleEntity>, relationEntities) => {
    if (typeof mainEntity === 'undefined') {
      return [];
    }

    if (typeof mainEntity.relationships === 'undefined') {
      throw new Error('getRelationEntities first argument should be a single JSON-API object entity');
    }
    if (typeof relationEntities === 'undefined') {
      throw new Error('getRelationEntities second argument should be an array of JSON-API relationship entities');
    }
    if (!mainEntity?.relationships?.[selectRelationEntityName]) {
      return [];
    }
    const relationshipObject = mainEntity?.relationships?.[selectRelationEntityName];
    const relationEntityIds = relationshipObject.data.map(item => item.id);

    return relationEntities.filter(relationEntity => relationEntityIds.includes(relationEntity.id));
  }
);
